<template>
    <q-table
        ref="table"
        :data="registrations"
        :columns="renderCols()"
        row-key="id"
        :pagination.sync="pagination"
        @request="requestRegistrations"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="id" :props="props">
						{{ props.row.id }}
				</q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="code" :props="props">
                    {{ props.row.code }}
                </q-td>

                <q-td key="presential_event_invite_date" :props="props">
                    {{props.row.presential_event_invite_date == null ? $t(getInviteDate(props.row.presential_event_invite_date)) : fDate(props.row.presential_event_invite_date)}}
                </q-td>

                 <q-td key="hr_start" :props="props">
                    {{ fDate(props.row.hr_start) }}
                 </q-td>

                 <q-td key="hr_end" :props="props">
                    {{ fDate(props.row.hr_end) }}
                 </q-td>

                <q-td key="qty_presential_event_dates" :props="props">
                    {{ props.row.qty_presential_event_dates + props.row.qty_presential_event_tests }}
                </q-td>

                <q-td key="qty_presential_event_tests_user_approved" :props="props">
                    {{ props.row.qty_presential_event_tests_user_approved + props.row.qty_presential_event_user_participant }}
                </q-td>

                <q-td key="presential_event_user_progress" :props="props">
                    {{ props.row.presential_event_user_progress}}%
                </q-td>

                <q-td key="event_type" :props="props">
                    {{ $t(getType(props.row.event_type)) }}
                </q-td>

                <q-td key="status" :props="props">
                    {{ $t(getStatus(props.row.status)) }}
                </q-td>

            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'Registrations',

    data() {
        return {
            pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns_vacancies: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'code',
                    required: true,
                    label: 'catalog_code',
                    align: 'left',
                    field: 'code',
                    sortable: true,
                },
                {
                    name: 'presential_event_invite_date',
                    required: true,
                    label: 'enrollment_date',
                    align: 'left',
                    field: 'presential_event_invite_date',
                    sortable: true,
                },
                {
                    name: 'hr_start',
                    required: true,
                    label: 'start_date',
                    align: 'left',
                    field: 'hr_start',
                    sortable: false,
                },
                {
                    name: 'hr_end',
                    required: true,
                    label: 'end_date',
                    align: 'left',
                    field: 'hr_end',
                    sortable: false,
                },
                {
                    name: 'qty_presential_event_dates',
                    required: true,
                    label: 'presential_event_qty',
                    align: 'left',
                    field: 'qty_presential_event_dates',
                    sortable: false,
                },
                {
                    name: 'qty_presential_event_tests_user_approved',
                    required: true,
                    label: 'presential_finished_events',
                    align: 'left',
                    field: 'qty_presential_event_tests_user_approved',
                    sortable: false,
                },
                {
                    name: 'presential_event_user_progress',
                    required: true,
                    label: 'progress',
                    align: 'left',
                    field: 'presential_event_user_progress',
                    sortable: false,
                },
                {
                    name: 'event_type',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'event_type',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                }
            ],
            columns_without_vacancies: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'presential_event_invite_date',
                    required: true,
                    label: 'enrollment_date',
                    align: 'left',
                    field: 'presential_event_invite_date',
                    sortable: true,
                },
                {
                    name: 'hr_start',
                    required: true,
                    label: 'start_date',
                    align: 'left',
                    field: 'hr_start',
                    sortable: false,
                },
                {
                    name: 'hr_end',
                    required: true,
                    label: 'end_date',
                    align: 'left',
                    field: 'hr_end',
                    sortable: false,
                },
                {
                    name: 'qty_presential_event_dates',
                    required: true,
                    label: 'presential_event_qty',
                    align: 'left',
                    field: 'qty_presential_event_dates',
                    sortable: false,
                },
                {
                    name: 'qty_presential_event_tests_user_approved',
                    required: true,
                    label: 'presential_finished_events',
                    align: 'left',
                    field: 'qty_presential_event_tests_user_approved',
                    sortable: false,
                },
                {
                    name: 'presential_event_user_progress',
                    required: true,
                    label: 'progress',
                    align: 'left',
                    field: 'presential_event_user_progress',
                    sortable: false,
                },
                {
                    name: 'event_type',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'event_type',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                }
            ],
            registrations: [],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            selected_user: 'users/selected_user',
            num_rows: 'datatable/num_rows',
            user_module_items: 'common/user_module_items',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestRegistrations({ pagination }) {
            this.loading = true
            this.pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination.rowsPerPage,
                "page": this.pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_presential_event_user_scheduled/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination.rowsNumber = response.data.count

                this.registrations = response.data.results.map(e => {
                    return { ...e }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination.rowsPerPage])
        },

        loadPagination() {
            this.pagination.rowsPerPage = this.num_rows
        },

        getStatus(status) {
            if(status == 1) return 'aproved'
            if(status == 2) return 'reproved'
            if(status == 3) return 'missed'
            if(status == 4)  return 'in_progress'
            if(status == null) return 'pending'
        },

        getType(type) {
            switch (type) {
                case 1: return 'opened'
                case 2: return 'closed'
                default:
                    break;
            }
        },

        getInviteDate(date) {
            if (date == null) {
                return 'self_enrolled'
            } else {
                return
            }
        },

        renderCols() {
			let item = this.user_module_items.find(
				(e) => e.slug === 'edit_presential_manager_seats'
			)
			if (item) return this.columns_vacancies
			else return this.columns_without_vacancies
		},
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.requestRegistrations({ pagination: this.pagination })
    }
}
</script>

<style>

</style>
